






































import {
  defineComponent,
  onMounted,
  ref,
  useFetch,
  useContext
} from '@nuxtjs/composition-api';
import { useCache, CacheTagPrefix } from '@vue-storefront/cache';
import EvidenceProducts from '~/components/solepro/EvidenceProducts.vue';
import Highlights from '~/components/solepro/Highlights.vue';
import TopicHighlights from '~/components/solepro/TopicHighlights.vue';
import HTMLContent from '~/components/solepro/HTMLContent.vue';
import ProductHighlights from '~/components/solepro/ProductHighlights.vue';
import PromoBanner from '~/components/solepro/PromoBanner.vue';
import PageLoading from '~/components/GlobalComponents/PageLoading.vue';
import { CmsBlock, useContent, useHome } from "~/composables";
import { pageView } from '~/helpers/trackings/24orepro/home';
import ClientOnly from 'vue-client-only';
import Spinner from '~/components/solepro/Spinner.vue';

export default defineComponent({
  name: 'PageResolver',
  components: {
    HTMLContent,
    Highlights,
    TopicHighlights,
    ProductHighlights,
    PromoBanner,
    PageLoading,
    EvidenceProducts,
    ClientOnly,
    Spinner
  },
  head() {

    /**
     * Organization Schema
    */

    const organization = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Il Sole 24 ORE Professionale",
      "url": `${(this.config as any).soleproDomain}/24orepro`,
      "logo": `${(this.config as any).soleproDomain}/resources/solepro/images/logo-positive.png`,
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+39 02 30300600", // @TODO non è meglio prendere dalle config?
        "email": "servizioclienti.online@ilsole24ore.com", // @TODO non è meglio prendere dalle config?
        "contactType": "customer service",
        "areaServed": "IT",
        "availableLanguage": "it"
      },
      "parentOrganization": {
        "@type": "Organization",
        "name": "Il Sole 24 ORE",
        "url": "https://www.ilsole24ore.com/"
      }
    }

    /**
     * Website Schema
    */

    const website = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "Il Sole 24 ORE Professionale",
      "description": "24ORE Professionale è l'area del Gruppo 24 ORE che sviluppa prodotti e servizi dedicati ai professionisti, alle aziende e alla pubblica amministrazione.",
      "url": `${(this.config as any).soleproDomain}/24orepro`
    }

    return {
      script: [
        {
          hid: 'ld-organization',
          type: 'application/ld+json',
          json: organization
        },
        {
          hid: 'ld-website',
          type: 'application/ld+json',
          json: website
        }
      ],
      meta:[{
        name:"google-site-verification",
        content:"OEWllNkIUmSoePVL7oxgo6xO5wolDHA81Ijl_xizEOo"
      }]
    }
  },
  setup() {
    const { loadBlocks } = useContent();
    const { addTags } = useCache();
    const { heroRendered, homeLoading } = useHome();
    const home_slider = ref<CmsBlock | null>(null);
    const promo_banner = ref<CmsBlock | null>(null);
    const news_banner = ref<CmsBlock | null>(null);
    const events_banner = ref<CmsBlock | null>(null);
    const { app: { $config } } = useContext();
    const loadingPromoBanner = ref<boolean>(false);
    const loadingEvidence = ref<boolean>(false);
    const trackPageView = async () => {
      pageView();
    };

    useFetch(async () => {
      homeLoading();
      const [cmsHomeSlider, cmsPromoBanner, cmsNewsBanner, cmsEventsBanner] = await Promise.all([
        loadBlocks({ identifiers: ["home_slider"] }),
        loadBlocks({ identifiers: ["home_promo_banner"] }),
        loadBlocks({ identifiers: ["home_news_banner"] }),
        loadBlocks({ identifiers: ["home_eventi"] }),
      ]);
      
      home_slider.value = cmsHomeSlider[0];
      promo_banner.value = cmsPromoBanner[0];
      news_banner.value = cmsNewsBanner[0];
      events_banner.value = cmsEventsBanner[0];
      
      addTags([{ prefix: CacheTagPrefix.View, value: 'home' }]);

    });
    onMounted(async ()=>{
      await trackPageView();
    })

    return {
      heroRendered,
      home_slider,
      promo_banner,
      news_banner,
      events_banner,
      config: $config,
      loadingPromoBanner,
      loadingEvidence
    };
  },

});
